import { SCOPES } from '../api';
import type { NavNode } from '@nyce/admin-kit/console';

const r = SCOPES.buddyRead;

/** The Buddy group's pages, in screen order (children of its node in `NAV`); quality, setup and knowledge are sub-groups. */
export const BUDDY_NAV: NavNode[] = [
  {
    path: '/buddy/usage',
    label: 'Usage',
    requires: r,
    description: 'nyce.buddy tokens, cost, questions and quality per organization, system, user or model.',
  },
  {
    id: 'buddy-quality',
    label: 'Quality',
    description: 'Feedback, failed queries and the request audit.',
    children: [
      {
        path: '/buddy/feedback',
        label: 'Feedback',
        requires: r,
        description: 'Thumbs up and down on answers: triage and reply.',
      },
      {
        path: '/buddy/failed-queries',
        label: 'Failed queries',
        requires: r,
        description: 'Literal queries the workservers rejected.',
      },
      {
        path: '/buddy/requests',
        label: 'Request audit',
        requires: r,
        description: 'Every API call with tokens, cost and duration.',
      },
    ],
  },
  {
    path: '/buddy/monitors',
    label: 'Monitors',
    requires: r,
    description: 'Agentic monitors: schedules, runs, alerts and actions.',
  },
  {
    id: 'buddy-setup',
    label: 'Setup',
    description: 'Organizations, systems, tenants, limits, models and DB servers.',
    children: [
      {
        path: '/buddy/organizations',
        label: 'Organizations',
        requires: r,
        description: 'Customers: settings, features, skills and documents.',
      },
      {
        path: '/buddy/systems',
        label: 'Systems',
        requires: r,
        description: 'Registrations of installations: access, flags, schema, provisioning.',
      },
      {
        path: '/buddy/tenants',
        label: 'Tenants',
        requires: r,
        description: 'Installations: workserver, service account, database.',
      },
      {
        path: '/buddy/access',
        label: 'Data access',
        requires: r,
        description: 'Which NYCE.LOGIC groups may read monetary values and personal data.',
      },
      {
        path: '/buddy/limits',
        label: 'Limits',
        requires: r,
        description: 'Monthly NYCE token limits per organization and system.',
      },
      {
        path: '/buddy/models',
        label: 'Models',
        requires: r,
        description: 'Global model settings, feature flags and pricing.',
      },
      {
        path: '/buddy/db-servers',
        label: 'DB servers',
        requires: r,
        description: 'Postgres servers buddy3 provisions on.',
      },
    ],
  },
  {
    id: 'buddy-knowledge',
    label: 'Knowledge',
    description: 'Skills, documentation and UI translations.',
    children: [
      {
        path: '/buddy/skills',
        label: 'Skills',
        requires: r,
        description: 'Skills and their validators.',
      },
      {
        path: '/buddy/docs',
        label: 'Documentation',
        requires: r,
        description: 'Documentation sources, crawls and search test.',
      },
      {
        path: '/buddy/translations',
        label: 'Translations',
        requires: r,
        description: 'UI texts per language: edit, auto-translate, import and export.',
      },
    ],
  },
];
